var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.418 34.0871L13.6406 32.3799C7.48903 31.3058 3 25.965 3 19.7204C3 16.2101 5.84566 13.3645 9.35593 13.3645H46.6441C50.1543 13.3645 53 16.2101 53 19.7204C53 25.965 48.511 31.3058 42.3594 32.3799L32.5746 34.0884",
    stroke: "white",
    strokeWidth: 3.49357,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2332 13.3643H18.7661V10.3558C18.7661 6.84542 21.6118 3.99988 25.122 3.99988H30.8772C34.3875 3.99988 37.2332 6.84542 37.2332 10.3558V13.3643Z",
    stroke: "white",
    strokeWidth: 3.49357,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4872 39.1018H23.5122V29.0364H32.4872V39.1018Z",
    stroke: "white",
    strokeWidth: 3.49357,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2353 28.0181V31.167V41.5235V45.6807C50.2353 49.1909 47.3897 52.0366 43.8794 52.0366H12.1196C8.60933 52.0366 5.76367 49.1909 5.76367 45.6807V31.167V28.0181",
    stroke: "white",
    strokeWidth: 3.49357,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.b427615350a798a4e5012d1a35668cc5.svg";
export { ForwardRef as ReactComponent };